import React, {useRef, useState} from 'react'
import {Button, FormGroup, Input} from "reactstrap";

// labels
import {LB_CREATE_LABEL, LB_MARK_TO_HOUR, LB_MARK_TO_MINUTES} from "../i18n/i18n";

/**
 * Componente para crear la etiqueta que se mostrará al asignar una horario recurrente
 * @param onLabelChange
 * @returns {JSX.Element}
 * @constructor
 */
const CreateRecurringScheduleLabel = ({onLabelChange}) => {
    const inputRef = useRef(null) // referencia para la caja de texto
    const [label, setLabel] = useState('') // label creada

    /**
     * Agregar una marca en la etiqueta que se está creando
     * @param mark
     */
    const addMark = mark => {
        const text = `${label}${mark}`

        setLabel(text)
        onLabelChange(text)
        inputRef.current.focus()
    }

    /**
     * Gestionar los cambios en la caja de texto
     * @param e
     */
    const onChangeLabel = e => {
        const text = e.target.value

        setLabel(text)
        onLabelChange(text)
    }

    return <>
        <h3>{LB_CREATE_LABEL}</h3>
        <br/>

        <div className={'label-container'}>
            <FormGroup>
                <Input
                    innerRef={inputRef}
                    type={'textarea'}
                    value={label}
                    onChange={ onChangeLabel }
                />
            </FormGroup>
            <Button color={'primary'} size={'sm'} onClick={ () => addMark('{hour}') }>{LB_MARK_TO_HOUR}</Button>
            &nbsp;
            <Button color={'primary'} size={'sm'} onClick={ () => addMark('{minutes}') }>{LB_MARK_TO_MINUTES}</Button>
        </div>
    </>
}

export default  CreateRecurringScheduleLabel